export default __webpack_public_path__ + "static/media/or.d073262a.PNG";